const UserIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M11.9993 11.9999C14.5307 11.9999 16.5827 9.94789 16.5827 7.41658C16.5827 4.88528 14.5307 2.83325 11.9993 2.83325C9.46804 2.83325 7.41602 4.88528 7.41602 7.41658C7.41602 9.94789 9.46804 11.9999 11.9993 11.9999Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8733 21.1667C19.8733 17.6192 16.3442 14.75 11.9992 14.75C7.65416 14.75 4.125 17.6192 4.125 21.1667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default UserIcon
